/** track 上报 log_action 枚举值 */
export enum TrackLogActionEnum {
  /** 访问页面 */
  PV = 'page_view',
  /** 接口响应 */
  RES = 'http_request',
}
